module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-dc32c772.png";